import  { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import "jspdf-autotable";
import { useAuth } from "../../../../AuthProvider";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GlobalStyles } from "@mui/system";

const AssigenedExamSubjectMarksList = ({ initialRows }) => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL || "";
  const navigate = useNavigate();
  const { userId,pId,oId,board,role} = useAuth();
  // const UserId = userId ;

  const [filteredData, setFilteredData] = useState([]);
  const [selectedExamType, setSelectedExamType] = useState("");
  const [loading, setLoading] = useState(false); // To handle button state
  const [exportAnchorEl, setExportAnchorEl] = useState(null);

  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };

  // State for tracking selected row for editing

  const [examTypeOptions, setExamTypeOptions] = useState([]);
  const [sscClassOptions, setSscClassOptions] = useState([]);
  const [sscSectionOptions, setSscSectionOptions] = useState([]);
  const [sscSelectedClass, setSscSelectedClass] = useState("");
  const [sscSelectedSection, setSscSelectedSection] = useState("");
  
  // INTERMEDIATE states
  const [interSectionOptions, setInterSectionOptions] = useState([]);
  const [interSelectedSection, setInterSelectedSection] = useState("");
  const [interSelectedClass, setInterSelectedClass] = useState("Inter-1st-Year");
  const [courseOptions, setCourseOptions] = useState([]);
  const [selectedCourseType, setSelectedCourseType] = useState("");
  const [sscClassSectionMap, setSscClassSectionMap] = useState({});


  //Dialog states
  const [selectedRow, setSelectedRow] = useState(null); // To store the row to edit
  const [isDialogOpen, setDialogOpen] = useState(false); // Dialog open state
  const [dialogbtnloading, setDialogbtnloading] = useState(false); // State for loading

  const handleExportClose = () => {
    setExportAnchorEl(null);
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState("");
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;
  const UserId = userId || selectedUsers;
 
    const fetchUsers = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/EXAMINATION_CELL/${oId}/${pId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch users');
            }
            const data = await response.json();
            setUsers(data);
            if (data.length > 0) {
              setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
          }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
useEffect(() => {
  if (isPrincipal) {
    fetchUsers();
  }
}, []); // ✅ Only runs on mount 





// -------------------------------------------
//           For SSC functions
// -------------------------------------------

// ---- Fetch Class + Sections for SSC (School) ----
//
const fetchClassRegistrationData = async () => {
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`
    );
    const data = await response.json();

    if (response.ok && Array.isArray(data)) {
      const classSectionMap = {};

      data.forEach((item) => {
        const className = item.classRegistration;
        const sections = item.sections.split(",").map((s) => s.trim());

        if (!classSectionMap[className]) {
          classSectionMap[className] = new Set();
        }

        sections.forEach((sec) => classSectionMap[className].add(sec));
      });

      const classes = Object.keys(classSectionMap);
      setSscClassOptions(classes);
      setSscClassSectionMap(classSectionMap);

      if (classes.length) {
        const defaultClass = classes[0];
        const sectionArray = [...classSectionMap[defaultClass]];

        setSscSelectedClass(defaultClass);
        setSscSectionOptions(sectionArray);
        setSscSelectedSection(sectionArray[0] || ""); // ✅ Select first section
      } else {
        setSscSelectedClass("");
        setSscSectionOptions([]);
        setSscSelectedSection("");
      }
    }
  } catch (error) {
    console.error("Error fetching SSC data:", error);
  }
};




// ---- Fetch Table Data for SSC ----
const fetchClassSectionTableData = async () => {
  if (!sscSelectedClass || !sscSelectedSection || !selectedExamType) {
    setFilteredData([]);

    setLoading(false);
    return;
  }
  setLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamicMarks/getAllMarks/${oId}/${pId}?romanNumberClass=${sscSelectedClass}&examType=${selectedExamType}`
    );     
    const data = await response.json();
    if (Array.isArray(data)) {
      setFilteredData(data);
      // setUniqueCourseType([...new Set(data.map(item => item.course))]);
    } else {
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching SSC table data:", error);
  } finally {
    setLoading(false);
  }
};




// -------------------------------------------
//           For Intermediate functions
// -------------------------------------------

// ---- Fetch Courses for INTERMEDIATE ----
const fetchCourseData = async () => {
  if(!interSelectedClass) return;
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllcoursesAccordingClasses/${pId}?romanNumberClass=${interSelectedClass}`);
    const data = await response.json();
    if (response.ok && Array.isArray(data)) {
      setCourseOptions(data);
      if (!selectedCourseType) {
        setSelectedCourseType(data[0] || "");
      }
    } else {
      setCourseOptions([]);
    }
  } catch (error) {
    console.error("Error fetching course data:", error);
    setCourseOptions([]);
  }
};

// ---- Fetch Sections for INTERMEDIATE ----
const fetchSectionsData = async () => {
  if (!interSelectedClass || !selectedCourseType) {
    setInterSectionOptions([]);
    return;
  }
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/getAllClass-registrations/${interSelectedClass}/${selectedCourseType}/${pId}`
    );
    const data = await response.json();
    if (response.ok && Array.isArray(data) && data.length > 0) {
      const sectionsString = data[0].sections;  // because your data is like [{ sections: "Section-A,Section-B" }]
      const sections = sectionsString.split(",").map(section => section.trim());
      
      setInterSectionOptions(sections);

      if (sections.length > 0) {
        setInterSelectedSection(sections[0]);
      } else {
        setInterSelectedSection("");
      }
    } else {
      setInterSectionOptions([]);
      setInterSelectedSection("");
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE data:", error);
  }
};




// ---- Fetch Table Data for INTERMEDIATE ----
const fetchCourseClassSectionTableData = async () => {
  if (!selectedCourseType || !interSelectedClass || !interSelectedSection || !selectedExamType) {
    setFilteredData([]);
    setLoading(false);
    return;
  }
  setLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/examCell/getClassAndSectionWithExamType/${oId}/${pId}/${UserId}?course=${selectedCourseType}&romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}&examType=${selectedExamType}`
    );
    const data = await response.json();
    if (Array.isArray(data)) {
      
      setFilteredData(data);
      // setUniqueCourseType([...new Set(data.map(item => item.course))]);
    } else {
     
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE table data:", error);
  } finally {
    setLoading(false);
  }
};



useEffect(() => {
  const loadClassData = async () => {
    if (board === "INTERMEDIATE") {
      await fetchSectionsData();
    } else if (board === "SSC") {
      await fetchClassRegistrationData();
    }
  };
  loadClassData();
}, [board,interSelectedClass, selectedCourseType, oId]);  // Removed selectedClass dependency here







// Fetch course options if board is INTERMEDIATE
useEffect(() => {
  if (board === "INTERMEDIATE") {
    fetchCourseData();
  }
}, [interSelectedClass,board, oId]);

// Fetch Table Data whenever filters change
useEffect(() => {
  if (board === "SSC") {
    if (!sscSelectedClass || !sscSelectedSection) {
   
      setFilteredData([]);
      setLoading(false); // ✅ stop loading even if API not called
      return;
    }
    fetchClassSectionTableData(); // Modify inside function to use sscSelectedClass and sscSelectedSection
  } else if (board === "INTERMEDIATE") {
    if (!interSelectedClass || !interSelectedSection || !selectedCourseType) {
    
      setFilteredData([]);
      
      setLoading(false); // ✅ same here
      return;
    }
    fetchCourseClassSectionTableData(); // Modify inside function to use interSelectedClass and interSelectedSection
  }
}, [board, sscSelectedClass, sscSelectedSection, interSelectedClass, interSelectedSection, selectedCourseType,selectedExamType]);




// //EXAM TYPE OPTIONS
useEffect(() => {
  const fetchExamTypeOptions = async () => {
    /* ── Guard clauses ─────────────────────────────── */
    if (!board || !pId) {
      setExamTypeOptions([]);
      setSelectedExamType("");
      return;                       // missing essentials
    }

    if (board === "SSC") {
      if (!sscSelectedClass) {
        setExamTypeOptions([]);
        setSelectedExamType("");
        return;                     // SSC needs class
      }
    } else if (board === "INTERMEDIATE") {
      if (!interSelectedClass || !selectedCourseType) {
        setExamTypeOptions([]);
        setSelectedExamType("");
        return;                     // Intermediate needs both
      }
    } else {
      setExamTypeOptions([]);       // unknown board
      setSelectedExamType("");
      return;
    }

    /* ── Build URL ─────────────────────────────────── */
    const url =
      board === "SSC"
        ? `${baseUrl}/api/dynamic-classReg/getAllExamsType/by-class/${pId}?classRegistration=${sscSelectedClass}`
        : `${baseUrl}/api/dynamic-classReg/getAllExamsType/by-class/${pId}?course=${selectedCourseType}&classRegistration=${interSelectedClass}`;

    /* ── Fetch ─────────────────────────────────────── */
    try {
      const response = await fetch(url);
      const data = await response.json();

      if (response.ok) {
        const uniqueTypes = [
          ...new Set(
            data
              .flatMap((entry) => entry.split(","))
              .map((t) => t.trim())
          ),
        ];
        setExamTypeOptions(uniqueTypes);
        setSelectedExamType(uniqueTypes[0] || "");
      } else {
        setExamTypeOptions([]);
        setSelectedExamType("");
      }
    } catch (err) {
      console.error("Error fetching exam types:", err);
      setExamTypeOptions([]);
      setSelectedExamType("");
    }
  };

  fetchExamTypeOptions();
}, [board, pId, sscSelectedClass, interSelectedClass, selectedCourseType]);





 const handleEditClick = (row) => {
    setSelectedRow(row); // Set the selected row
    setDialogOpen(true); // Open the dialog
  };



  const handleDialogClose = () => {
    setDialogOpen(false); // Close the dialog
    setSelectedRow(null); // Clear the selected row
  };

const handleSaveChanges = async () => {
  if (!selectedRow) {
    toast.error("Invalid selection.");
    return;
  }

  const { subjects, subjectMarks, overallMarks, marksId } = selectedRow;

  if (!subjects || !subjectMarks || !overallMarks) {
    toast.error("Please fill in all editable fields.");
    return;
  }

  setDialogbtnloading(true);

  try {
    // Build query params
    const queryParams = new URLSearchParams({
      // subjects: subjects,
      subjectMarks: subjectMarks,
      overallMarks: overallMarks,
    }).toString();

    const url = `${baseUrl}/api/dynamicMarks/update/${pId}/${marksId}?${queryParams}`;

    const response = await fetch(url, {
      method: "PATCH",
    });

    const responseText = await response.text();

    if (!response.ok) {
      throw new Error(responseText || "Failed to update details.");
    }

    toast.success(responseText || "Details updated successfully!");
    fetchClassSectionTableData();
    handleDialogClose();
  } catch (error) {
    console.error("Error updating details:", error);
    toast.error(`Error: ${error.message}`);
  } finally {
    setDialogbtnloading(false);
  }
};

  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
      <Card
        sx={{
          marginTop: "60px",
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <CardContent>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
<Box
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between", // left and right sides
    width: "100%",                  // full width ensures space-between works
    mb: 2,
  }}
>
  {/* Left: Back icon + title */}
  <Box display="flex" alignItems="center" gap={1}>
    {/* <IconButton
      onClick={() => navigate(-1)}
      sx={{ color: "#2e2a54" }}
    >
      <KeyboardBackspaceIcon fontSize="medium" />
    </IconButton> */}
    <Typography
      variant="h4"
      sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
    >
      Scheduled Examination Marks
    </Typography>
  </Box>

  {/* Right: Button */}
  <Button
    variant="contained"
    sx={{
      backgroundColor: "#3C3972",
      width: "180px",
      height: "40px",
      color: "white",
      fontWeight: "bold",
      "&:hover": { backgroundColor: "#3C3972" },
    }}
    onClick={() => navigate("/AssignExamSubjectMarksForm")}
  >
    Schedule Exam Marks
  </Button>
</Box>


          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div>
              <Box display="flex" mb={3} flexWrap="wrap">
                {/* Select Class */}



{board === "SSC" && (
  <>
    <FormControl size="small" sx={{ minWidth: 120,marginRight:2}}>
      <InputLabel id="class-select-label">Select Class</InputLabel>
      <Select
        labelId="class-select-label"
        value={sscSelectedClass}
       

        onChange={(e) => {
          const selected = e.target.value;
          setSscSelectedClass(selected);
          // setMode("classSection");
      
          const sections = sscClassSectionMap[selected] ? Array.from(sscClassSectionMap[selected]) : [];
          setSscSectionOptions(sections);
          setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0] || "");
        }}
        
        label="Select Class"
        sx={{ height: 35 }}
      >
        {sscClassOptions.map((cls) => (
          <MenuItem key={cls} value={cls}>{cls}</MenuItem>
        ))}
      </Select>
    </FormControl>

     </>
)}


{board === "INTERMEDIATE" && (
  <>
    <FormControl size="small" sx={{ minWidth: 120,marginRight:2}}>
      <InputLabel id="intermediate-class-select-label">Select Year</InputLabel>
      <Select
        labelId="intermediate-class-select-label"
        value={interSelectedClass}
        onChange={(e) => setInterSelectedClass(e.target.value)}
        label="Select Year"
        sx={{ height: 35 }}
      >
        <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
        <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
      </Select>
    </FormControl>

    <FormControl size="small" sx={{ minWidth: 120,marginRight:2}}>
      <InputLabel id="course-type-label">Select Course</InputLabel>
      <Select
        labelId="course-type-label"
        value={selectedCourseType}
        // onChange={(e) => setSelectedCourseType(e.target.value)}
        onChange={(e) => {
          setSelectedCourseType(e.target.value);
          // setMode("classSection");
        }}
        
        label="Select Course"
        sx={{ height: 35 }}
      >
        {courseOptions.map((course, index) => (
          <MenuItem key={index} value={course}>{course}</MenuItem>
        ))}
      </Select>
    </FormControl>

  
    <FormControl size="small" sx={{ minWidth: 120 ,marginRight:2}}>
  <InputLabel id="intermediate-section-select-label">Select Section</InputLabel>
  <Select
    labelId="intermediate-section-select-label"
    value={interSelectedSection || ""}
    onChange={(e) => {
      setInterSelectedSection(e.target.value);
      // setMode("classSection");
    }}
    label="Select Section"
    sx={{ height: 35 }}
  >
    {interSectionOptions.length === 0 ? (
      <MenuItem value="" disabled>
        Select Year and Course
      </MenuItem>
    ) : (
      interSectionOptions.map((section, index) => (
        <MenuItem key={index} value={section}>
          {section}
        </MenuItem>
      ))
    )}
  </Select>
</FormControl>

  </>
)}
         

                {/* Exam Type */}
                <FormControl sx={{ width: 140, ml: 1 }} size="small">
                  <InputLabel>Exam Type</InputLabel>
                  <Select
                    value={selectedExamType}
                    onChange={(e) => setSelectedExamType(e.target.value)}
                    label="Exam Type"
                  >
                    {examTypeOptions.map((type) => (
                      <MenuItem key={type} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

              </Box>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                gap: "5px",
              }}
            >             
            </div>
          </div>

          <GlobalStyles
                            styles={{
                              '.custom-sidebar-scrollbar': {
                                scrollbarWidth: 'thin', // For Firefox
                                scrollbarColor: 'grey #e0e0e0',
                              },
                              '.custom-sidebar-scrollbar::-webkit-scrollbar': {
                                width: '6px', // For WebKit-based browsers
                              },
                              '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
                                background: '#f1f1f1', // Track color
                              },
                              '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
                                backgroundColor: 'grey', // Thumb color
                                borderRadius: '10px',
                              },
                              '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
                                backgroundColor: '#555',
                              },
                            }}
                          />

          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              maxHeight: "69vh",
              overflow: "auto",
            }}
            className="custom-sidebar-scrollbar"
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    S.No
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    {board === "INTERMEDIATE" ? "Year" : "Class"}
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    Exam Type
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    Subject
                  </TableCell>                  
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    Marks
                  </TableCell>
                   {/* <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    OverAll Marks
                  </TableCell> */}
                  <TableCell
                                    sx={{
                                      borderRight: "1px solid #ddd",
                                      padding: "2px",
                                      textAlign: "center",
                                      backgroundColor: "#fff9c4",
                                       fontWeight:'bold' ,
                                      fontSize:'14px'
                                    }}
                                  >
                                    Action
                                  </TableCell>
                </TableRow>
              </TableHead>
              {loading ? (
                <TableBody>
                  <TableRow>

                    <TableCell
                      colSpan={12}
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                      >
                        <CircularProgress />
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          Loading Data...
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : filteredData.length === 0 ? (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={13} sx={{ textAlign: "center" }}>
                      No data found
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  {filteredData.map((row, index) => (
                    <TableRow
                      key={row.admissionNumber}
                      style={{
                        backgroundColor: "white",
                        transition: "background-color 0.3s",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "white"; // Default color
                      }}
                    >
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {index + 1}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.romanNumberClass}
                      </TableCell>
                     
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.examType}
                      </TableCell>


                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                        }}
                      >
                        {row.subjects}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.subjectMarks}
                      </TableCell>
                       {/* <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                        }}
                      >
                        {row.overallMarks}
                      </TableCell> */}

                        <TableCell sx={{ textAlign: "center", padding: "2px", borderRight: "1px solid #ddd", }}>
                       <Box
                                                  sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    gap: "4px",
                                                  }}
                                                >
                 
                        <Button
                                                    sx={{
                                                      backgroundColor: "#1565c0",
                                                      color: "white",
                                                      "&:hover": { backgroundColor: "#0d47a1" },
                                                      // borderRadius: 2,
                                                      padding: "2px 4px",
                                                    }}
                                                    onClick={() => handleEditClick(row)}
                                                  >
                                                    Edit
                                                  </Button>
                                                  </Box>
                    </TableCell>

                     
                    </TableRow>
                  ))}
                </TableBody>
              )}
            </Table>
          </TableContainer>

      {/* Dialog for editing */}
                <Dialog open={isDialogOpen} onClose={handleDialogClose} size="xs">
                  <DialogTitle style={{ fontWeight: "bold"}}>Edit Details</DialogTitle>
                  <DialogContent>
                    <Grid container spacing={1}>
                      <Grid  fullWidth item xs={6}>
                        <TextField
                          label="Class"
                          value={selectedRow ? selectedRow.romanNumberClass : ""}
                          onChange={(e) =>
                            setSelectedRow((prevState) => ({
                              ...prevState,
                              romanNumberClass: e.target.value,
                            }))
                          }
                          fullWidth
                          margin="normal"
                          disabled
                          InputProps={{
                            style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'},
                          }}
                        />
                      </Grid>
        
                      <Grid item xs={6} fullWidth>
                        <TextField
                          label="Exam Type"
                          value={selectedRow ? selectedRow.examType : ""}
                          onChange={(e) =>
                            setSelectedRow((prevState) => ({
                              ...prevState,
                              examType: e.target.value,
                            }))
                          }
                          fullWidth
                          margin="normal"
                          disabled
                          InputProps={{
                            style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'},
                          }}
                        />
                      </Grid>
                       <Grid item xs={6} fullWidth>
                        <TextField
                          label="Subject"
                          value={selectedRow ? selectedRow.subjects : ""}
                          onChange={(e) =>
                            setSelectedRow((prevState) => ({
                              ...prevState,
                              subjects: e.target.value,
                            }))
                          }
                          fullWidth
                          margin="normal"
                         disabled
                          InputProps={{
                            style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'},
                          }}
                        />
                      </Grid>
                       <Grid item xs={6} fullWidth>
                        <TextField
                          label="Subject Marks"
                          value={selectedRow ? selectedRow.subjectMarks : ""}
                          onChange={(e) =>
                            setSelectedRow((prevState) => ({
                              ...prevState,
                              subjectMarks: e.target.value,
                            }))
                          }
                          fullWidth
                          margin="normal"
                          
                        />
                      </Grid>
                       <Grid item xs={6} fullWidth>
                        <TextField
                          label="OverAll Marks"
                          value={selectedRow ? selectedRow.overallMarks : ""}
                          onChange={(e) =>
                            setSelectedRow((prevState) => ({
                              ...prevState,
                              overallMarks: e.target.value,
                            }))
                          }
                          fullWidth
                          margin="normal"
                         
                        />
                      </Grid>
                     
                  
                    </Grid>
                  </DialogContent>
                  <DialogActions>
                  <Button
          onClick={handleDialogClose}
          color="primary"
          variant="outlined"
        
        >
          Cancel
        </Button>
        
        <Button
          onClick={handleSaveChanges}
          color="primary"
          variant="contained"
          disabled={dialogbtnloading} // Disable when loading
          sx={{
            fontWeight: 600,
            backgroundColor: "#3C3972",
            "&:hover": { backgroundColor: "#3C3972" },
          }}
        >
          {dialogbtnloading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Save"}
        </Button>
        
                  </DialogActions>
                </Dialog>



        </CardContent>
        <ToastContainer position="top-right" autoClose={2000} />
      </Card>
    </Box>
  );
};

export default AssigenedExamSubjectMarksList;